
<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate [formGroup]="StudentEdit">
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <!-- <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-18 mg-b-5">All Exam Records</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">Exam Data</li>
                            </ol>
                        </div>
                    </div> -->
                    <div class="bc d-flex align-items-center pl-3 pb-3">
                        <img alt="Logo" src="../../assets/img/ExamMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                          <h3 class="main-content-label mb-1"><b>
                            Exam Setting
                            </b></h3>
                          <p class="text-muted card-sub-title mb-0">
                            Exam Dynamic Information
                          </p>
                        </div>
                      </div>
                    <mat-accordion>
                        <mat-expansion-panel  (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header >
                                <mat-panel-title (click)="getData('Course')">
                                <div class="row pt-5 pb-5 mt-2 mb-2">
                                    <div class="col-sm-2 mt-3 mb-3">
                                    <img src="../../assets/img/id-card.png" class="mt9 wd16">
                                    </div>
                                    <div class="col-sm-5  mt-2">
                                        <h5 class="lh4 mt-3  main-content-label">Course</h5>
                                    </div>
                                 </div>   
                                </mat-panel-title>
                                
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Action
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="Course">
                                        <tr  *ngFor="let Coursedetail of getCourseControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                {{Coursedetail.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control">
                                            </td>
                                            
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select (selectionChange)="visableChange(i,Coursedetail.value,'Course')" formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Required</mat-label>
                                                    <mat-select   formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td class="text-center">
                                                <!-- <button
                                                        class="mat-focus-indicator btn btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            >Update</button> -->
                                                            <a (click)="updateDetails(Coursedetail)" title="Edit" class="btn-floating"><i  class="fa fa-edit" aria-hidden="true"></i></a> 
                                                         </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button> -->
                            </div>
                        </mat-expansion-panel>
                        
                        <mat-expansion-panel  (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header >
                                <mat-panel-title (click)="getData('ExamData')">
                                    <div class="row pt-5 pb-5 mt-2 mb-2">
                                        <div class="col-sm-2 mt-3 mb-3">
                                        <img src="../../assets/img/id-card.png" class="mt9" style="width: 17rem;">
                                        </div>
                                        <div class="col-sm-5 mt-2 ">
                                            <h5 class="lh4 mt-3  main-content-label">Exam</h5>
                                        </div>
                                     </div>   
                                </mat-panel-title>
                                
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Action
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="ExamData">
                                        <tr  *ngFor="let pdetail of getExamDataControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                {{pdetail.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control">
                                            </td>
                                            
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select (selectionChange)="visableChange(i,pdetail.value,'ExamData')" formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Required</mat-label>
                                                    <mat-select   formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td class="text-center">
                                             <a (click)="updateDetails(pdetail)" title="Edit" class="btn-floating"><i  class="fa fa-edit" aria-hidden="true"></i></a> 
                                             </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </mat-expansion-panel>

                        <mat-expansion-panel  (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header >
                                <mat-panel-title (click)="getData('Migration')">
                                    <div class="row pt-5 pb-5 mt-2 mb-2">
                                        <div class="col-sm-2 mt-3 mb-3">
                                        <img src="../../assets/img/id-card.png" class="mt9"  style="width: 10rem;">
                                        </div>
                                        <div class="col-sm-5 mt-2 ">
                                            <h5 class="lh4 mt-3  main-content-label">Migration Certificate</h5>
                                        </div>
                                     </div>   
                                </mat-panel-title>
                                
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Action
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="Migration">
                                        <tr  *ngFor="let pdetail of getMigrationDataControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                {{pdetail.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control">
                                            </td>
                                            
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select (selectionChange)="visableChange(i,pdetail.value,'Migration')" formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Required</mat-label>
                                                    <mat-select   formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td class="text-center">
                                             <a (click)="updateDetails(pdetail)" title="Edit" class="btn-floating"><i  class="fa fa-edit" aria-hidden="true"></i></a> 
                                             </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </mat-expansion-panel>

                        <mat-expansion-panel  (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header >
                                <mat-panel-title (click)="getData('RankData')">
                                    <div class="row pt-5 pb-5 mt-2 mb-2">
                                        <div class="col-sm-2 mt-3 mb-3">
                                        <img src="../../assets/img/id-card.png" class="mt9" style="width: 12rem;">
                                        </div>
                                        <div class="col-sm-5 mt-2 ">
                                            <h5 class="lh4 mt-3  main-content-label">Rank Certificate</h5>
                                        </div>
                                     </div>   
                                </mat-panel-title>
                                
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Action
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="RankData">
                                        <tr  *ngFor="let pdetail of getRankDataControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                {{pdetail.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control">
                                            </td>
                                            
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select (selectionChange)="visableChange(i,pdetail.value,'RankData')" formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Required</mat-label>
                                                    <mat-select   formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td class="text-center">
                                             <a (click)="updateDetails(pdetail)" title="Edit" class="btn-floating"><i  class="fa fa-edit" aria-hidden="true"></i></a> 
                                             </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </mat-expansion-panel>

                        <mat-expansion-panel  (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header >
                                <mat-panel-title (click)="getData('Passing')">
                                    <div class="row pt-5 pb-5 mt-2 mb-2">
                                        <div class="col-sm-2 mt-3 mb-3">
                                        <img src="../../assets/img/id-card.png" class="mt9" style="width: 8rem;">
                                        </div>
                                        <div class="col-sm-5 mt-2 ">
                                            <h5 class="lh4 mt-3  main-content-label">Original Passing Certificate</h5>
                                        </div>
                                     </div>   
                                </mat-panel-title>
                                
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Action
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="Passing">
                                        <tr  *ngFor="let pdetail of getPassingDataControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                {{pdetail.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control">
                                            </td>
                                            
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select (selectionChange)="visableChange(i,pdetail.value,'Passing')" formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Required</mat-label>
                                                    <mat-select   formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td class="text-center">
                                             <a (click)="updateDetails(pdetail)" title="Edit" class="btn-floating"><i  class="fa fa-edit" aria-hidden="true"></i></a> 
                                             </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </mat-expansion-panel>

                        <mat-expansion-panel  (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header >
                                <mat-panel-title (click)="getData('Provisional')">
                                    <div class="row pt-5 pb-5 mt-2 mb-2">
                                        <div class="col-sm-2 mt-3 mb-3">
                                        <img src="../../assets/img/id-card.png" class="mt9"  style="width: 8rem;">
                                        </div>
                                        <div class="col-sm-5 mt-2 ">
                                            <h5 class="lh4 mt-3  main-content-label">Provisional Pass Certificate</h5>
                                        </div>
                                     </div>   
                                </mat-panel-title>
                                
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Action
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="Provisional">
                                        <tr  *ngFor="let pdetail of getProvisionalDataControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                {{pdetail.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control">
                                            </td>
                                            
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select (selectionChange)="visableChange(i,pdetail.value,'Provisional')" formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Required</mat-label>
                                                    <mat-select   formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td class="text-center">
                                             <a (click)="updateDetails(pdetail)" title="Edit" class="btn-floating"><i  class="fa fa-edit" aria-hidden="true"></i></a> 
                                             </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </mat-expansion-panel>

                        <mat-expansion-panel  (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header >
                                <mat-panel-title (click)="getData('Grievance')">
                                <div class="row pt-5 pb-5 mt-2 mb-2">
                                    <div class="col-sm-2 mt-3 mb-3">
                                    <img src="../../assets/img/id-card.png" class="mt9 wd16">
                                    </div>
                                    <div class="col-sm-5  mt-2">
                                        <h5 class="lh4 mt-3  main-content-label">Grievance</h5>
                                    </div>
                                 </div>   
                                </mat-panel-title>
                                
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Action
                                            </th>
                                            <!-- <th class="f600">
                                        Pattern
                                    </th> -->
                                            <!-- <th width="10%" class="f600 text-center">Action</th> -->
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="Grievance">
                                        <tr  *ngFor="let grievancedetail of getGrievanceControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                {{grievancedetail.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control">
                                            </td>
                                            
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select (selectionChange)="visableChange(i,grievancedetail.value,'Grievance')" formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Required</mat-label>
                                                    <mat-select   formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td class="text-center">
                                                <!-- <button
                                                        class="mat-focus-indicator btn btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                            >Update</button> -->
                                                            <a (click)="updateDetails(grievancedetail)" title="Edit" class="btn-floating"><i  class="fa fa-edit" aria-hidden="true"></i></a> 
                                                         </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="Regnext()">Next</button>
                                <button
                                    class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                    (click)="save()">Save</button> -->
                            </div>
                        </mat-expansion-panel>
                        <!-- <mat-expansion-panel  (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header >
                                <mat-panel-title (click)="getData('DivisionBranch')">
                                 <div class="row pt-5 pb-5 mt-2 mb-2">
                                    <div class="col-sm-2 mt-3 mb-3">
                                    <img width="200rem" src="../../assets/img/id-card.png">
                                    </div>
                                    <div class="col-sm-5  ">
                                        <h5 class="lh4">Exam Division</h5>
                                    </div>
                                 </div>   
                                </mat-panel-title>
                                
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="DivisionBranch">
                                        <tr  *ngFor="let EDdetail of getDivisionBranchControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                {{EDdetail.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control">
                                            </td>
                                            
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select (selectionChange)="visableChange(i,EDdetail.value,'DivisionBranch')" formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Required</mat-label>
                                                    <mat-select   formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td class="text-center">
                                               <a (click)="updateDetails(EDdetail)" title="Edit" class="btn-floating"><i  class="fa fa-edit" aria-hidden="true"></i></a> 
                                                         </td>
                                        </tr>
                                    </tbody>
                                </table>
                               
                            </div>
                        </mat-expansion-panel> -->
                        <!-- <mat-expansion-panel  (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header >
                                <mat-panel-title (click)="getData('AggregateExam')">
                                 <div class="row pt-5 pb-5 mt-2 mb-2">
                                    <div class="col-sm-2 mt-3 mb-3">
                                    <img width="200rem" src="../../assets/img/id-card.png">
                                    </div>
                                    <div class="col-sm-5  ">
                                        <h5 class="lh4">Exam Aggregate</h5>
                                    </div>
                                 </div>   
                                </mat-panel-title>
                                
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Action
                                            </th>
                                             </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="AggregateExam">
                                        <tr  *ngFor="let EAdetail of getAggregateExamControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                {{EAdetail.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control">
                                            </td>
                                            
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select (selectionChange)="visableChange(i,EAdetail.value,'AggregateExam')" formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Required</mat-label>
                                                    <mat-select   formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td class="text-center">
                                                           <a (click)="updateDetails(EAdetail)" title="Edit" class="btn-floating"><i  class="fa fa-edit" aria-hidden="true"></i></a> 
                                                         </td>
                                        </tr>
                                    </tbody>
                                </table>
                               
                            </div>
                        </mat-expansion-panel> -->
                        <!-- <mat-expansion-panel  (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header >
                                <mat-panel-title (click)="getData('ExamSchedule')">
                                 <div class="row pt-5 pb-5 mt-2 mb-2">
                                    <div class="col-sm-2 mt-3 mb-3">
                                    <img width="200rem" src="../../assets/img/id-card.png">
                                    </div>
                                    <div class="col-sm-5  ">
                                        <h5 class="lh4">Exam Schedule</h5>
                                    </div>
                                 </div>   
                                </mat-panel-title>
                                
                            </mat-expansion-panel-header>
                            <div class="table-responsive">
                                <table id="datatable" class="table table-bordered text-left">
                                    <thead>
                                        <tr>

                                            <th class="f600">
                                                Name
                                            </th>
                                            <th class="f600">
                                                Display
                                            </th>
                                            
                                            <th class="f600">
                                                Visible
                                            </th>
                                            <th class="f600">
                                                Require
                                            </th>
                                            <th class="f600">
                                                Action
                                            </th>
                                            </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="ExamSchedule">
                                        <tr  *ngFor="let ESdetail of getExamScheduleControls(); let i = index" [formGroupName]="i">

                                            <td width="20%">
                                                {{ESdetail.controls['FormName'].value}}
                                            </td>
                                            <td width="30%">
                                                <input formControlName="FormDisplayName" class="form-control">
                                            </td>
                                            
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Choose an option</mat-label>
                                                    <mat-select (selectionChange)="visableChange(i,ESdetail.value,'ExamSchedule')" formControlName="FormVisible">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td>
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Required</mat-label>
                                                    <mat-select   formControlName="FormRequired">
                                                        <mat-option [value]="true">
                                                            Yes
                                                        </mat-option>
                                                        <mat-option [value]="false">
                                                            No
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </td>
                                            <td class="text-center">
                                                            <a (click)="updateDetails(ESdetail)" title="Edit" class="btn-floating"><i  class="fa fa-edit" aria-hidden="true"></i></a> 
                                                         </td>
                                        </tr>
                                    </tbody>
                                </table>
                                
                            </div>
                        </mat-expansion-panel> -->
                    </mat-accordion>

                </div>
            </div>
        </div>
    </form>
</body>